import { useQuery } from "@apollo/client/react";
import { GetDentistProductPreferencesDocument } from "../../gql/generated/graphql";
import type { ApolloError } from "@apollo/client";
import type { DentistProductPreferences } from "@jasper/client-models";

interface Props {
  dentistId?: string;
}

export const useDentistProductPreferences = ({
  dentistId,
}: Props): {
  dentistProductPreferences?: DentistProductPreferences;
  isLoading: boolean;
  error?: ApolloError;
} => {
  const { data, loading, error } = useQuery(
    GetDentistProductPreferencesDocument,
    {
      variables: { dentistId: dentistId ?? "" },
      skip: !dentistId,
    }
  );

  return {
    dentistProductPreferences: data?.getUserProductPreferences
      ? {
          shadeType: data.getUserProductPreferences.shadeType,
          fixedProsthesisPreferences:
            data.getUserProductPreferences.fixedProsthesisPreferences ?? [],
        }
      : undefined,
    isLoading: loading,
    error,
  };
};
